module.exports = __webpack_public_path__ + "static/media/ArmyValues2-6.684cf8f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/ArmyValues2-6.svg
// module id = 647
// module chunks = 0